<div class="adf-empty-search-result">
    <ng-content></ng-content>
</div>
